import { DOCS_LINKS, uuid } from "@hex/common";
import * as monaco from "monaco-editor";

export const PUBLIC_HEX_SL_FILE_YAML_LANGUAGE = {
  /** Unfortunately for us, `monaco-yaml` which we use to validate the schema
   * inline, requires the name of the language be `"yaml"`, which means we may
   * have a name conflict here with the "pure" YAML language without any of our
   * add-ons. Given that this is the only YAML monaco editor in the app at this
   * time, we're okay with this conflict for now. */
  id: "yaml" as const,
  extension: ".hex.yaml" as const,
  docsUrl: DOCS_LINKS.SemanticAuthoringModelingSpecification,
};

/**
 * Returns a monaco uri which will be validated by the HexSL YAML schema.
 */
export function publicHexSLFileYamlUri(path?: string): monaco.Uri {
  return monaco.Uri.file(
    `/${path ?? uuid()}${PUBLIC_HEX_SL_FILE_YAML_LANGUAGE.extension}`,
  );
}
/**
 * Undoes the transformation done by `publicHexSLFileYamlUri`, allowing
 * you to get the path passed in to `publicHexSLFileYamlUri` from the uri.
 *
 * @example
 * ```ts
 * const path = "somePath"
 * const uri = publicHexSLFileYamlUri(path)
 * assert publicHexSLFileYamlUri.getPath(uri) === path
 * ```
 */
publicHexSLFileYamlUri.getPath = (uri: monaco.Uri): string => {
  return uri.path
    .split("/")
    .slice(1)
    .join("/")
    .split(".")
    .slice(0, -2)
    .join(".");
};
